export function formatMoneyAmount(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '—';
  return value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
}

/**
 * @param {{ price?: number|string, compare_at_price?: number|string|null, currency?: string }} product
 */
export function getProductSalePricing(product) {
  const salePrice = Number(product?.price);
  const compareAtRaw = product?.compare_at_price;
  const compareAt = compareAtRaw === null || compareAtRaw === undefined || compareAtRaw === ''
    ? NaN
    : Number(compareAtRaw);
  const currency = product?.currency || 'USD';
  const hasDiscount = Number.isFinite(salePrice)
    && salePrice > 0
    && Number.isFinite(compareAt)
    && compareAt > salePrice;
  const discountPercent = hasDiscount
    ? Math.round((1 - salePrice / compareAt) * 100)
    : 0;

  return {
    salePrice,
    compareAt,
    currency,
    hasDiscount,
    discountPercent
  };
}

export function formatProductPriceLine(amount, currency, suffix = '') {
  if (!Number.isFinite(Number(amount)) || Number(amount) <= 0) return null;
  return `${currency || 'USD'} ${formatMoneyAmount(amount)}${suffix}`;
}
